import { DictionaryItem } from '@hglobal/common';

export enum Role {
  Admin = 'admin',
  SuperAdmin = 'Superadmin',
  Buyer = 'buyer',
  Supervisor = 'Supervisor',
}

export enum RoleFromAPI {
  Admin = 'admin',
  SuperAdmin = 'Super admin',
  Buyer = 'buyer',
  Supervisor = 'Supervisor',
}

export interface RolePermissions {
  active: boolean;
  canAdd: string[];
  canDelete: string[];
  canInvite: string[];
  permissions: unknown[];
  role: RoleFromAPI;
}

export const parseRoleFromApi = (role: Role | string): Role => {
  return role.replaceAll(/\s/g, '') as Role;
};

export const mapRolesFromApi = (roles: RolePermissions[], rolesDictionary: Map<Role, string>): DictionaryItem<string>[] => {
  const mappedRoles = [];

  for (const item of roles) {
    const parsedRole = parseRoleFromApi(item.role);
    const mappedRole = rolesDictionary.get(parsedRole);
    if (mappedRole) {
      mappedRoles.push({ id: parsedRole, name: mappedRole });
    }
  }

  return mappedRoles;
};
